import React from 'react';
import './Roadmap.css';

const Roadmap = () => {
  const phases = [
    {
      phase: 'Phase 1',
      title: 'Select USDT',
      description: 'Choose your preferred USDT network from our supported options.',
      status: 'active'
    },
    {
      phase: 'Phase 2',
      title: 'Terms',
      description: 'Review and accept our terms and conditions for a secure transaction.',
      status: 'upcoming'
    },
    {
      phase: 'Phase 3',
      title: 'Pay',
      description: 'Complete your payment using your preferred method.',
      status: 'upcoming'
    },
    {
      phase: 'Phase 4',
      title: 'Send it',
      description: 'Receive your Flash USDT instantly in your wallet.',
      status: 'upcoming'
    }
  ];

  return (
    <section className="roadmap" id="roadmap">
      <div className="container">
        <div className="roadmap-header">
          <h2>Simple <span className="highlight">4-Step Process</span></h2>
          <p className="subtitle">Get your Flash USDT in minutes</p>
        </div>

        <div className="roadmap-grid">
          {phases.map((phase, index) => (
            <div key={index} className={`roadmap-card ${phase.status}`}>
              <div className="phase-number">{index + 1}</div>
              <div className="phase-label">{phase.phase}</div>
              <h3>{phase.title}</h3>
              <p>{phase.description}</p>
              {phase.status === 'active' && (
                <div className="active-badge">Current Step</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
